<template>
  <div>
    <b-modal ref="modalPrivacyConsent" hide-footer title="Privacy Statement">
      <div class="d-block">
        <p class="fw-600">
          Submit Application :
          <span class="badge bg-amended">{{ quoteId }}</span>
        </p>

        <div class="row" v-if="Object.hasOwn(dealerInfo, 'name')">
          <div class="col-12">
            <appWDDealer :dealerInfo="dealerInfo"></appWDDealer>
          </div>
        </div>

        <p class="text-danger">Thank you for submitting this application.</p>
        <p class="text-danger">
          Please confirm you have a signed Privacy Form and have attached the
          following documents for a assessment.
        </p>
        <ol>
          <li>Applications latest two payslips.</li>
          <li>
            ID Verification – Clear copy of Applications Driver License front
            and rear.
          </li>
          <li>Signed Privacy Form.</li>
        </ol>
        <p class="text-danger">
          To ensure we mange client expectations for document signing and
          settlement please complete the estimated delivery data below. If
          unknown please complete the most accurate estimate.
        </p>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <b-form-input
                id="edd"
                type="date"
                autocomplete="off_edd"
                placeholder=" "
                v-model="vehicle.edd"
              >
              </b-form-input>
              <label class="floatingLabel" for="leaseTerm"
                >Expected Delivery Date</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['vehicle.edd']"
              >
                {{ fnReplace(getQuoteErrors['vehicle.edd']) }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 text-left">
            <b-form-checkbox
              id="checkbox-1"
              v-model="vehicle.privacyConsent"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
            >
              Tick Box accepting Terms
            </b-form-checkbox>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['vehicle.privacyConsent']"
            >
              {{ fnReplace(getQuoteErrors['vehicle.privacyConsent']) }}
            </div>
          </div>
          <div class="col-6 text-right" v-if="vehicle.privacyConsent == 1">
            <button
              type="button"
              class="btn btn-primary"
              @click="fnPrivacyConsentConfirm(1)"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../services/auth.service'
import appWDDealer from '../../components/wd/WDDealer.vue'

export default {
  name: 'quoteStep5',
  props: ['propsData', 'quoteType'],
  components: {
    appWDDealer
  },
  data() {
    return {
      userData: {},
      errors: {},
      quoteId: this.$route.params.quoteId,
      documentId: '',
      is_spinActive: false,
      privacyConsent: 0,
      step: 5,
      isSave: false,
      dealerInfo: {},
      // client_vehicle_details
      vehicle: {
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: '',
        salaryPackagingProviderFee: '',
        vehicleCondition: '',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: '',
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: '',
        fuelTypeId: '',
        colour: '',
        accessories: '',
        term: '',
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: '',
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: '',
        stampDuty: '',
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: '',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: '',
        dealerBrokerage: '',
        status: '',
        sortOrder: '',
        has_messages: '',
        messages_for_vsa: '',
        messages_for_other: '',
        privacyConsent: '',
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: '',
        dateOfBirth: '',
        anotherNameYesNo: '',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: '',
        maritalStatus: '',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: '',
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: '',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: '',
        hAddressTimeAtYears: '',
        hAddressTimeAtMonths: '',
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: '',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: '',
        postalAddressAndHomeAddressAreSameYesNo: '',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_details
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: '',
        employerAddressTimeAtMonths: '',
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: '',
        pEmployerAddressTimeAtMonths: '',
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: '',
        govConvertibleIncome: '',
        otherIncome: '',
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanBalance: '',
        homeLoanLimit: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: ''
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      }
    }
  },
  computed: {
    ...mapGetters(['getQuoteErrors', 'getSaveApplication'])
  },
  methods: {
    ...mapActions([
      'fetchQuoteSingle',
      'fetchIsLock',
      'fetchQuoteErrors',
      'fetchSaveApplication'
    ]),

    fnModalHide() {
      this.$refs['modalPrivacyConsent'].hide()
    },
    fnModalShow() {
      this.vehicle.clientId = this.propsData.clientId
      this.vehicle.dealerId = this.propsData.dealerId
      this.vehicle.referralPartnerId = this.propsData.referralPartnerId
      this.vehicle.referDealerId = this.propsData.referDealerId
      this.vehicle.leadSource = this.propsData.leadSource
      this.vehicle.salaryPackagingProviderId =
        this.propsData.salaryPackagingProviderId
      this.vehicle.salaryPackagingProviderFee =
        this.propsData.salaryPackagingProviderFee
      this.vehicle.vehicleCondition = this.propsData.vehicleCondition
      this.vehicle.odometerReading = this.propsData.odometerReading
      this.vehicle.year = this.propsData.year
      this.vehicle.make = this.propsData.make
      this.vehicle.model = this.propsData.model
      this.vehicle.variant = this.propsData.variant
      this.vehicle.bodyType = this.propsData.bodyType
      this.vehicle.vehicleCategoryId = this.propsData.vehicleCategoryId
      this.vehicle.fuelFlatRate = this.propsData.fuelFlatRate
      this.vehicle.fuelCostPerKM = this.propsData.fuelCostPerKM
      this.vehicle.tyresCostPerKM = this.propsData.tyresCostPerKM
      this.vehicle.serviceCostPerKM = this.propsData.serviceCostPerKM
      this.vehicle.transmissionId = this.propsData.transmissionId
      this.vehicle.fuelTypeId = this.propsData.fuelTypeId
      this.vehicle.colour = this.propsData.colour
      this.vehicle.accessories = this.propsData.accessories
      this.vehicle.term = this.propsData.term
      this.vehicle.rvRate = this.propsData.rvRate
      this.vehicle.annualKms = this.propsData.annualKms
      this.vehicle.noFinanceInsurance = this.propsData.noFinanceInsurance
      this.vehicle.comprehensiveInsurer = this.propsData.comprehensiveInsurer
      this.vehicle.comprehensiveInsurancePremium =
        this.propsData.comprehensiveInsurancePremium
      this.vehicle.businessUsePercentage = this.propsData.businessUsePercentage
      this.vehicle.stampDuty = this.propsData.stampDuty
      this.vehicle.registration = this.propsData.registration
      this.vehicle.gstOnAsset = this.propsData.gstOnAsset
      this.vehicle.gstOnAssetActual = this.propsData.gstOnAssetActual
      this.vehicle.totalDriveAwayCost = this.propsData.totalDriveAwayCost
      this.vehicle.chanageBudgetsYesNo = this.propsData.chanageBudgetsYesNo
      this.vehicle.fuelBudget = this.propsData.fuelBudget
      this.vehicle.serviceBudget = this.propsData.serviceBudget
      this.vehicle.tyreBudget = this.propsData.tyreBudget
      this.vehicle.needToCompeteYesNo = this.propsData.needToCompeteYesNo
      this.vehicle.dealerBrokerage = this.propsData.dealerBrokerage
      this.vehicle.status = this.propsData.status
      this.vehicle.sortOrder = this.propsData.sortOrder
      this.vehicle.has_messages = this.propsData.has_messages
      this.vehicle.messages_for_vsa = this.propsData.messages_for_vsa
      this.vehicle.messages_for_other = this.propsData.messages_for_other
      this.vehicle.privacyConsent = this.propsData.privacyConsent
      this.vehicle.settlementDate = this.propsData.settlementDate
      this.vehicle.fa_no = this.propsData.fa_no
      this.vehicle.edd = this.propsData.edd

      Object.assign(this.client, this.propsData.client)
      Object.assign(this.employment, this.propsData.client_employment_detail)
      Object.assign(this.finance, this.propsData.client_finance_detail)
      Object.assign(this.notes, this.propsData.client_application_notes)
      Object.assign(this.lookupValues, this.propsData.client_lookup_values)
      Object.assign(this.dealerInfo, this.propsData.dealer)

      this.$refs['modalPrivacyConsent'].show()
    },

    /**
     * Update if quote in draft mode (status = 1) and check document update consent confirm
     */
    fnPrivacyConsentConfirm: async function (value) {
      // Get propsData status (initial)
      const { status: propsDataStatus } = this.vehicle
      // To Unlock
      this.fetchIsLock(false)
      if (value == 1 && propsDataStatus == 1 && this.quoteType == 'quote') {
        /**
         * On submit
         * status = 2
         * privacyConsent = 1
         */
        this.vehicle.privacyConsent = 1
        this.vehicle.status = 2

        await this.fnCallSubmit()

        // To lock
        this.fetchIsLock(true)
      }

      if (value == 1 && propsDataStatus != 1 && this.quoteType == 'quote') {
        /**
         * On submit
         * status = 3
         * privacyConsent = 1
         */
        this.vehicle.privacyConsent = 1
        this.vehicle.status = 3

        await this.fnCallSubmit()

        // To lock
        this.fetchIsLock(true)

        return
      }

      if (value == 1 && this.quoteType == 'leads') {
        /**
         * On submit
         * status = 23
         * privacyConsent = 1
         */
        this.vehicle.privacyConsent = 1
        this.vehicle.status = 23

        await this.fnCallSubmit()

        // To lock
        this.fetchIsLock(true)

        return
      }

      if (
        this.getQuoteErrors &&
        this.getQuoteErrors.vehicle &&
        this.getQuoteErrors.vehicle.edd &&
        this.getQuoteErrors.vehicle.edd.length == 0
      ) {
        this.fnModalHide()
      }

      return
    },

    fnCallSubmit: async function () {
      try {
        const allData = {
          quoteType: this.quoteType,
          submit_mode: 'submit',
          quoteId: this.quoteId,
          vehicle: this.vehicle,
          client: this.client,
          employment: this.employment,
          finance: this.finance,
          lookupValues: this.lookupValues,
          notes: this.notes
        }
        await this.fetchSaveApplication(allData)
        await this.fetchQuoteSingle({
          id: this.quoteId,
          quoteType: this.quoteType
        })
      } catch (error) {
        console.log(error)
      } finally {
        if (this.getSaveApplication == 'success') {
          this.fnModalHide()
        }
      }
    },

    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    }
  },
  created() {
    this.userData = authService.getUserFromToken()
  }
}
</script>
